<template>
  <div class="bg-area">
    <!--关于森锐-->
    <div class="bg-item" v-show="currentRouteIndex === 0">
      <div
        class="bg-wrap"
        :style="{ 'background-image': 'url(' + bgAboutSr + ')' }"
      ></div>
      <div class="join-us" style="width: 898px; margin-left: -449px">
        客户为先&nbsp;&nbsp;产品为本&nbsp;&nbsp;激情创新&nbsp;&nbsp;诚信和谐
      </div>
    </div>
    <!--产品-->
    <div class="bg-item" v-show="currentRouteIndex === 1">
      <div
        class="bg-wrap"
        :style="{ 'background-image': 'url(' + bgProducts + ')' }"
      ></div>
      <div class="products-text">
        <h2>智能终端设备</h2>
        <p>
          <span>多业务办理</span>
          <span>多行业使用</span>
          <span>多功能集成</span>
        </p>
      </div>
    </div>
    <!--解决方案-->
    <div class="bg-item" v-show="currentRouteIndex === 2">
      <div
        class="bg-wrap"
        :style="{ 'background-image': 'url(' + bgSolution + ')' }"
      ></div>
      <div class="solution-text">
        <h2>打造个性化行业解决方案</h2>
        <span>为用户提供一站式的产品与服务</span>
      </div>
    </div>
    <!--支持与服务-->
    <div class="bg-item" v-show="currentRouteIndex === 3">
      <div
        class="bg-wrap"
        :style="{ 'background-image': 'url(' + bgSupport + ')' }"
        style="background-position: center center"
      ></div>
      <div class="search-box yd-display-flex yd-alignItems">
        <!--<div  class="select ">-->
        <!--<div @click="selectEvent" class="yd-display-flex yd-justifyContent-s yd-alignItems" style="height: 100%;">-->
        <!--<span >全部内容</span>-->
        <!--<img  src="../../assets/images/blackArrowDownIcon.png">-->
        <!--</div>-->
        <!--<div id="selectContainer" class="select-container">-->
        <!--<div>时间</div>-->
        <!--<div>区域</div>-->
        <!--<div>大小</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="search yd-display-flex yd-alignItems">-->
        <!--<input v-model.trim="params.inputVal" type="text" placeholder="搜索支持与服务" />-->
        <!--<img @click="searchEvent" src="../../assets/images/searchIcon.png" title="搜索">-->
        <!--</div>-->
      </div>
      <div class="solution-text">
        <h2>支持与服务</h2>
        <span>为用户提供一站式的产品与服务</span>
      </div>
    </div>
    <!---->
    <div class="bg-item" v-show="currentRouteIndex === 4">
      <div
        class="bg-wrap"
        :style="{ 'background-image': 'url(' + bgJoinUs + ')' }"
        style="background-position: center center"
      ></div>
      <div class="join-us">加入森锐，成就梦想</div>
    </div>
  </div>
</template>

<script>
import bgAboutSr from "@/assets/images/bgAboutSr.jpg";
import bgProducts from "@/assets/images/bgProducts.png";
import bgSolution from "@/assets/images/bgSolution.jpg";
import bgSupport from "@/assets/images/bgSupport.jpg";
import bgJoinUs from "@/assets/images/bgJoinUs.jpg";
export default {
  name: "index",
  data() {
    return {
      bgAboutSr,
      bgProducts,
      bgSolution,
      bgSupport,
      bgJoinUs,
      currentRouteIndex: 0,
      params: {
        inputVal: "",
        selectVal: "",
      },
    };
  },
  watch: {
    $route: "routerHandle",
  },
  mounted() {
    this.routerHandle();
  },
  methods: {
    selectEvent() {
      if ($("#selectContainer").css("display") == "none") {
        $("#selectContainer").slideDown();
      } else {
        $("#selectContainer").slideUp();
      }
    },
    // 搜索事件
    searchEvent() {
      if (!this.params.inputVal && !this.params.selectVal) {
        this.$notify.info({
          title: "温馨提示",
          message: "请输入选择/输入搜索条件",
        });
      } else {
        this.$root.Bus.$emit("support-pageCustomi-search-event", this.params);
      }
    },
    routerHandle() {
      let _this = this;
      let currentRouter = _this.$route.path;
      //              0           1           2           3
      let pages = ["aboutSr", "products", "solution", "support", "joinUs"];
      pages.forEach((item, index) => {
        if (currentRouter.indexOf(item) !== -1) {
          _this.currentRouteIndex = index;
        }
      });
    },
  },
};
</script>

<style scoped>
.bg-area {
  width: 100%;
  height: 500px;
  position: relative;
}
.bg-item {
  width: 100%;
  height: 100%;
}
.bg-wrap {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}
/**/
.products-text {
  position: absolute;
  top: 159px;
  left: 18%;
  color: #fff;
}
.products-text h2 {
  font-size: 56px;
  margin-bottom: 8px;
  font-weight: 300;
  line-height: 81px;
  text-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}
.products-text p span {
  margin-right: 36px;
  font-size: 26px;
  font-weight: 300;
  text-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}
/**/
.solution-text {
  text-align: left;
  position: absolute;
  left: 18.3%;
  top: 185px;
  color: #fff;
  width: 528px;
}
.solution-text h2 {
  font-size: 48px;
  font-weight: 400;
  line-height: 64px;
  margin-bottom: 10px;
  text-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}
.solution-text span {
  font-weight: 400;
  line-height: 37px;
  font-size: 28px;
  text-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}
.join-us {
  position: absolute;
  top: 153px;
  left: 50%;
  margin-left: -225px;
  width: 450px;
  height: 70px;
  font-size: 48px;
  font-weight: 500;
  line-height: 70px;
  color: rgba(255, 255, 255, 1);
  text-shadow: 3px 3px 0px rgba(0, 13, 133, 0.15);
}
/**/
/*search*/
.search-box {
  position: absolute;
  top: 44%;
  width: 540px;
  left: 50%;
  margin-left: -270px;
}
.search-box .select {
  width: 140px;
  height: 40px;
  margin-right: 14px;
  background: #fff;
  position: relative;
  box-sizing: border-box;
  padding: 0 8px;
  user-select: none;
  cursor: pointer;
}
.search-box .select span {
  font-size: 13px;
  color: #d1d1d1;
}
.search-box .select img {
  width: 8px;
  height: 8px;
}
.search-box .search {
  background: #fff;
  box-sizing: border-box;
  padding: 0 12px;
  height: 40px;
  overflow: hidden;
}
.search-box .search input {
  border: none;
  margin: 0;
  width: 340px;
}
.search-box .search img {
  width: 18px;
  cursor: pointer;
}
/*select*/
.select-container {
  position: absolute;
  top: 41px;
  left: 0;
  width: 120px;
  background: #fff;
  border-radius: 2px;
  overflow: hidden;
  text-align: left;
  border: 1px solid #f5f5f5;
  box-sizing: border-box;
  display: none;
}
.select-container > div {
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 0 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #d1d1d1;
}
.select-container > div:hover {
  color: #2e81e1;
}
/*适配*/
@media (max-width: 1800px) {
  .solution-text {
    left: 5.6%;
  }
  .products-text {
    left: 5.6%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topImageArea/index.vue